import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withFadeInUpAnimation from '../../hocs/withFadeInUpAnimation'


export class SelectPlanCard extends Component {
  render() {
    const { name, price, features, selectPlan, stripe_plan_id, description } = this.props

    return (
      <div id="select-plan-card" className="card shadow text-center">
        <div className={`card-body ${name === 'Family Plan' && 'most-popular'}`}>
          <div>
            <h3 className="color-body">{name}</h3>
            <div style={{background: '#ececec', margin: '0 -20px', padding: '30px 0 15px'}}>
              <h1 className="color-blue m-0" style={{fontWeight: 800, fontSize: 40}}><sup>$</sup>{price}</h1>
              <h6 className="color-blue" style={{fontWeight: 600}}>/year</h6>
              <p className="mb-0" style={{fontSize: 14}}>{description}</p>
            </div>
            <br/>
            <ul>{features.map(feature => <li className="text-left" key={feature}>{feature}</li>)}</ul>
            <br/>
            <button
              className="btn btn-lg btn-block btn-primary"
              onClick={() => selectPlan(stripe_plan_id)}
            >
              Free Trial
            </button>
          </div>
        </div>
      </div>
    )
  }
}

SelectPlanCard.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  features: PropTypes.array.isRequired,
  selectPlan: PropTypes.func.isRequired,
  stripe_plan_id: PropTypes.string.isRequired,
}

export default withFadeInUpAnimation(SelectPlanCard)



// WEBPACK FOOTER //
// ./src/components/ui/cards/SelectPlanCard.js